module.exports = __webpack_public_path__ + "img/uae-logo.cfb1ed04.png";